import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { mq } from './_shared/media';
import { StyledH2Light } from './_shared/styled-headings';
import { StyledPLight } from './_shared/styled-headings';
import { StyledP } from './_shared/styled-headings';
import { StyledTag } from './_shared/styled-headings';
import { flexCenter } from './_shared/styled-mixins';
import { StyledSection } from './_shared/styled-section';
import ButtonLink from './links/button-link';

const StyledBlock = styled(StyledSection)`
  background-color: var(--lightbg-color);
  width: 100%;
  display: flex;
  ${flexCenter};
  flex-direction: column;
  padding: 3rem 0;

  color: var(--lightbg-content-color);
  text-align: center;
  font-size: 0.8rem;
`;

const StyledContent = styled.div`
  width: 100%;
  padding: 4rem calc((var(--space) / 2));
  text-align: center;
  font-size: 0.8rem;
`;

const StyledFeatureGridContainer = styled.section`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 1rem;
  padding: 2rem;
  width: 100%;

  ${mq.gt.sm} {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 1.5rem;
  }
`;
const StyledFeatureCard = styled.div`
  background-color: #fff;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 1rem 0.8rem;
  text-align: left !important;
  max-width: 560px;
  margin: 0 auto;

  border: 2px solid #fff;
  border-radius: var(--radius);
  box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease 0s;
  outline: none;

  &:hover {
    border-color: var(--secondary-color) !important;
  }
`;

const StyledCardLabel = styled(StyledP)`
  font-size: 0.9rem;
  font-weight: 800;
  color: var(--primary-color);
`;
const StyledFeatureDescription = styled.p`
  font-size: 0.7rem;
  margin: 0 auto;
  text-align: center !important ;
`;

const BtnContainer = styled.div`
  max-width: 200px !important;
  margin: 0 auto;
`;

const Steps = ({ data }) => {
  const { cards, summary, title, id = null } = data;

  const featureStep = cards.map(({ label, description }, index) => {
    return (
      <StyledFeatureCard key={index}>
        <StyledCardLabel>{label}</StyledCardLabel>
        <StyledFeatureDescription>{description}</StyledFeatureDescription>
      </StyledFeatureCard>
    );
  });

  return (
    <StyledBlock id={id}>
      <StyledContent>
        <StyledTag>How Do I Join?</StyledTag>
        {title && <StyledH2Light>{title}</StyledH2Light>}
        <StyledPLight dangerouslySetInnerHTML={{ __html: summary }} />
        <StyledFeatureGridContainer>{featureStep}</StyledFeatureGridContainer>
        <BtnContainer>
          <ButtonLink label="Sign up, It's Free" link="/join" />
        </BtnContainer>
      </StyledContent>
    </StyledBlock>
  );
};

Steps.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Steps;
